// extracted by mini-css-extract-plugin
export default {"buttonApprove":"styles_buttonApprove__mR0bN"};